import {
  Tile,
  TileContent,
  TileGroup,
  TileText,
} from '@one-thd/sui-atomic-components';
import { GridView, ListView } from '@one-thd/sui-icons';
import classNames from 'classnames';
import React, { ChangeEvent } from 'react';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { pushEventInfo } from '../../../utils/analytics';
import { getWindow } from '../../../utils/general';
import {
  getAccountScopedStorageKey,
  VIEW_TYPE_STORAGE_KEY,
} from '../../../utils/user';

const baseTileData = [
  {
    value: 'Card',
    text: 'Card View',
    icon: <GridView color="current" size="small" />,
  },
  {
    value: 'Table',
    text: 'Table View',
    icon: <ListView color="current" size="small" />,
  },
];

const activeOrdersTile = {
  value: 'activeOrders',
  text: 'Active Orders View',
  icon: <ListView color="current" size="small" />,
};

export const OrderViewToggle = () => {
  const { viewType, setViewType } = usePurchaseHistoryContext();

  // Active Orders tile is only rendered (and therefore only selectable)
  // when enableActiveOrdersTable is on.
  const tileData = FeatureSwitches.enableActiveOrdersTable
    ? [...baseTileData, activeOrdersTile]
    : baseTileData;

  return (
    <div className="sui-mr-3" data-testid="orderViewToggle">
      <TileGroup
        onChange={(
          _event: ChangeEvent<HTMLInputElement>,
          newViewType: string,
        ) => {
          if (newViewType) {
            setViewType(newViewType);

            // activeOrders should not be set in localStorage
            if (newViewType !== 'activeOrders') {
              const viewTypeStorageKey = getAccountScopedStorageKey(
                VIEW_TYPE_STORAGE_KEY,
              );
              if (viewTypeStorageKey) {
                getWindow()?.localStorage.setItem(
                  viewTypeStorageKey,
                  newViewType,
                );
              }
            }

            pushEventInfo({
              category: { primaryCategory: 'button submission' },
              eventInfo: { eventName: 'my account settings' },
              myAccount: {
                settings: `purchase history: toggle: ${(() => {
                  if (newViewType === 'Card') {
                    return 'card';
                  }
                  if (newViewType === 'Table') {
                    return 'list';
                  }
                  if (newViewType === 'activeOrders') {
                    return 'active orders';
                  }
                  return '';
                })()} view`,
              },
            });
          }
        }}
        value={viewType}
        aria-label="View Options"
      >
        {tileData.map((item, key) => (
          <Tile key={key} value={item.value} aria-label={item.text}>
            <TileContent>
              <span
                className={classNames('sui-pt-1', {
                  'sui-text-brand': viewType === item.value,
                })}
              >
                {item.icon}
              </span>
              <TileText>{item.text}</TileText>
            </TileContent>
          </Tile>
        ))}
      </TileGroup>
    </div>
  );
};
